// src/types/Warehouse.ts
export interface WarehouseAddress {
  street: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
}

export interface WarehouseContact {
  phone: string;
  email: string;
  manager: string;
}

export interface WarehouseCapacity {
  total: number;
  used: number;
  available: number;
}

export type WeekDay =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export const WEEK_DAYS: WeekDay[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export interface DayHours {
  isOpen: boolean;
  open: string;
  close: string;
}

export interface WarehouseOperatingHours {
  open: string;
  close: string;
  timezone: string;
  days?: Record<WeekDay, DayHours>;
}

export const createDefaultWeekHours = (
  open = '09:00',
  close = '18:00'
): Record<WeekDay, DayHours> => ({
  monday: { isOpen: true, open, close },
  tuesday: { isOpen: true, open, close },
  wednesday: { isOpen: true, open, close },
  thursday: { isOpen: true, open, close },
  friday: { isOpen: true, open, close },
  saturday: { isOpen: false, open, close },
  sunday: { isOpen: false, open, close },
});

export interface Warehouse {
  id?: string;
  name: string;
  code: string;
  description: string;
  address: WarehouseAddress;
  contact: WarehouseContact;
  capacity: WarehouseCapacity;
  isActive: boolean;
  displayInWebsite?: boolean;
  operatingHours?: WarehouseOperatingHours;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  createdByName?: string;
  updatedBy?: string;
  updatedByName?: string;
}

export interface WarehouseFormData {
  name: string;
  code: string;
  description: string;
  address: WarehouseAddress;
  contact: WarehouseContact;
  capacity: {
    total: string;
    used: string;
  };
  isActive: boolean;
  displayInWebsite: boolean;
  operatingHours: WarehouseOperatingHours;
}

export interface WarehouseStats {
  total: number;
  active: number;
  inactive: number;
  totalCapacity: number;
  usedCapacity: number;
  availableCapacity: number;
  utilizationRate: number;
}